export type BrandLogo = {
  /** URL path under `public/` (e.g. `/next.png`, `/brands/x.svg`) */
  src: string;
  alt: string;
  /** Optional scale multiplier for logos that appear too small (e.g. 1.5) */
  scale?: number;
};

/**
 * Partner logos for the home marquee — files live in `public/` (project root),
 * not only `public/brands/`. Raster and SVG are supported.
 *
 * Intentionally omitted from this list: team portraits, certification badges
 * (FSC, ISO, Sedex), material swatches, and hero graphics — add those only if
 * you want them in the marquee.
 */
export const BRAND_LOGOS: BrandLogo[] = [
  { src: "/brands/asda.png", alt: "Asda" },
  { src: "/brands/b&m.png", alt: "B&M" },
  { src: "/brands/casa.png", alt: "Casa" },
  { src: "/brands/CatherineLansfield.png", alt: "Catherine Lansfield" },
  { src: "/brands/comfy.png", alt: "Comfy Quilts" },
  { src: "/brands/Debenham.png", alt: "Debenham" },
  { src: "/brands/dorma.png", alt: "Dorma" },
  { src: "/brands/dunelm.png", alt: "Dunelm" },
  { src: "/brands/kibek.png", alt: "Kibek" },
  { src: "/brands/lidl.png", alt: "Lidl" },
  { src: "/brands/mark.png", alt: "Marks & Spencer" },
  { src: "/brands/mio.png", alt: "Mio" },
  { src: "/brands/next.png", alt: "Next" },
  { src: "/brands/primark.png", alt: "Primark" },
  { src: "/brands/silentnight.png", alt: "Silentnight" },
  { src: "/brands/tchibo.png", alt: "Tchibo" },
  { src: "/brands/waitrose.png", alt: "Waitrose" },
  { src: "/brands/dari.png", alt: "Dari" },
  { src: "/brands/lama.png", alt: "Lama" },
  { src: "/brands/qalb.png", alt: "Qalb" },
  { src: "/brands/tana.png", alt: "Tana", scale: 2.8 },
  { src: "/brands/urban.png", alt: "Urban" },
];
